export const getName = (name) => {
  const cleanedName = name.replaceAll(/\([^()]*\)/g, '').trim()

  // Split the name into parts
  const nameParts = cleanedName.includes(',')
    ? cleanedName.split(', ').reverse() // Reverse to get [FirstName, LastName]
    : cleanedName.split(/\s+/).filter(Boolean) // Split by spaces and remove empty parts

  return nameParts
}

export const getInitials = (name) => {
  if (!name) {
    return ''
  }

  // Remove any extra text like "(External)" and trim whitespace
  const nameParts = getName(name)

  // Generate initials dynamically
  const initials = nameParts
    .slice(0, 3) // Take up to the first three parts of the name
    .map((part) => part[0]?.toUpperCase()) // Get the first letter of each part
    .join('') // Combine them into a single string

  return initials
}

export const getWelcomeMsg = (name) => {
  if (!name) {
    return 'Welcome!'
  }

  // Remove any extra text like "(External)" and trim whitespace
  const nameParts = getName(name)

  // Return the first name
  return `Welcome, ${nameParts[0]}!`
}
